exports.f = require('./_wks');



//////////////////
// WEBPACK FOOTER
// ../core-js/library/modules/_wks-ext.js
// module id = 353
// module chunks = 22